import { type SearchRequest } from '@searchkit/api';

import { createQueryFactory } from '~/apps/product-plus/search-domain/pipelines/player-data/query-factory';
import { type SearchDomainContext } from '~/apps/product-plus/search-domain/types';

export function buildPlayerDataQuery(_context: SearchDomainContext, searchRequest: SearchRequest) {
  const queryFactory = createQueryFactory();
  return queryFactory(searchRequest);
}
